import { Bouton } from './composants/bouton'
import { useEffect, useState } from 'react'


const sousIos = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)

/**
 * Aperçu immédiat du PDF généré localement, puis envoi : feuille de partage du
 * téléphone (e-mail, SMS, WhatsApp… avec le PDF joint), sinon téléchargement
 * et e-mail à compléter. Un brouillon transmis est marqué « envoyé » par
 * l'artisan : l'app ne peut pas savoir si le partage est allé au client.
 */
export function ApercuPdf(props: { pdf: Blob; titre?: string; nom: string; sujet: string; destinataire?: string; fermer: () => void; marquerEnvoye?: () => Promise<void> }) {
  const [url] = useState(() => URL.createObjectURL(props.pdf))
  const [transmis, setTransmis] = useState(false)
  useEffect(() => () => URL.revokeObjectURL(url), [url])
  const fichier = new File([props.pdf], props.nom, { type: 'application/pdf' })
  const partageable = typeof navigator.canShare === 'function' && navigator.canShare({ files: [fichier] })
  const texte = `Bonjour,\n\nVeuillez trouver ci-joint notre ${props.sujet.toLowerCase()}.\n\nCordialement`
  const mailto = `mailto:${props.destinataire ? encodeURIComponent(props.destinataire).replace(/%40/g, '@') : ''}?subject=${encodeURIComponent(props.sujet)}&body=${encodeURIComponent(texte)}`

  return (
    <div className="fixed inset-0 z-30 mx-auto flex max-w-md flex-col bg-white lg:max-w-4xl">
      {sousIos ? (
        // Safari iOS laisse le cadre blanc pour un PDF en blob: : on l'ouvre dans sa propre visionneuse
        <div className="flex flex-1 flex-col items-center justify-center gap-4 p-6 text-center">
          <p className="text-lg font-semibold">{props.titre ?? 'Aperçu du devis'}</p>
          <Bouton asChild variante="secondaire">
            <a href={url} target="_blank" rel="noopener">
              Ouvrir l’aperçu du PDF
            </a>
          </Bouton>
        </div>
      ) : (
        <iframe title={props.titre ?? 'Aperçu du devis'} src={url} className="flex-1 border-0" />
      )}
      {props.marquerEnvoye && (
        <div className={`flex items-center justify-between gap-3 border-t p-3 text-sm ${transmis ? 'border-nuit bg-slate-100' : 'border-slate-300'}`}>
          <span>{transmis ? 'Transmis au client ?' : 'Une fois transmis au client :'}</span>
          <Bouton variante="secondaire" className="shrink-0" onClick={props.marquerEnvoye}>
            Marquer comme envoyé
          </Bouton>
        </div>
      )}
      {!partageable && props.marquerEnvoye && (
        <p className="px-4 pb-1 text-sm text-slate-700">
          Téléchargez le PDF puis <a className="underline" href={mailto} onClick={() => setTransmis(true)}>ouvrez un e-mail</a> pour le
          joindre.
        </p>
      )}
      <nav className="flex gap-3 border-t border-slate-300 p-4 pb-[max(1rem,env(safe-area-inset-bottom))]">
        <Bouton variante="secondaire" className="flex-1" onClick={props.fermer}>
          Fermer
        </Bouton>
        {partageable ? (
          <Bouton
            className="flex-1"
            onClick={() =>
              navigator
                .share({ files: [fichier], title: props.sujet, text: texte })
                .then(() => setTransmis(true))
                .catch(() => {}) // partage annulé
            }
          >
            {props.marquerEnvoye ? 'Envoyer' : 'Partager'}
          </Bouton>
        ) : (
          <Bouton asChild className="flex-1">
            <a href={url} download={props.nom} onClick={() => setTransmis(true)}>
              Télécharger
            </a>
          </Bouton>
        )}
      </nav>
    </div>
  )
}
